import React from 'react';
import PropTypes from 'prop-types';

import styles from './TextPageHeader.scss';

const TextPageHeader = ({ title, description }) => {
  return (
    <header className="TextPageHeader">
      <div className="TextPageHeader__container">
        <h2 className="TextPageHeader__headline">{title}</h2>
        {description}
      </div>
    </header>
  );
};

TextPageHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
  // This will frequently be a translatable string, but it will
  // end up as one or multiple lines of text.
  description: PropTypes.element,
};

export default TextPageHeader;
